export enum SnackType {
  Primary = 'primary',
  Success = 'success',
  Error = 'error',
  Info = 'info',
  Warning = 'warning',
}

export interface Snack {
  msg: string;
  type: SnackType;
}
